import { View, Text, StyleSheet, ActivityIndicator } from "react-native";
import { BASE_URL, FRONTEND_URL } from "../../api/axios";
import { createStackNavigator } from "@react-navigation/stack";
import { Platform } from "react-native";

import React, { useContext, useEffect, useRef, useState } from "react";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { NavigationContainer } from "@react-navigation/native";
import GetStartedNavigation from "./GetStartedNavigation";
import TabNavigations from "./TabNavigations";
import AppContext from "../../context/AppContext";
import Colours from "../../utils/Colours";
import AnonymousOnboarding from "../anonymousOnboarding/AnonymousOnboarding";
import AnonymousOnboardingOTP from "../anonymousOnboarding/AnonymousOnboardingOTP";
import PayForTable from "../anonymousOnboarding/PayForTable";
import GoogleSign from "../signInScreen/GoogleSign";
import SignUpScreen from "../signInScreen/SignUpScreen";
import PersonalDetailsScreen from "../signInScreen/PersonalDetailsScreen";
import IdentityScreen from "../signInScreen/IdentityScreen";
import TableInvitationCheckout from "../anonymousOnboarding/TableInvitationCheckout";
import CreateYourVirtualTableScreen from "../anonymousOnboarding/CreateYourVirtualTableScreen";
import WaitForBillsPage from "../anonymousOnboarding/WaitForBillsPage";
import BrandMenuScreen from "../anonymousOnboarding/BrandMenuScreen";
import ChooseYourFlexSpend from "../anonymousOnboarding/ChooseYourFlexSpend";
import { useNavigationContainerRef } from "@react-navigation/native";
import RevisitChooseYourSpend from "../anonymousOnboarding/RevisitChooseYourSpend";
import RevisitMenu from "../anonymousOnboarding/RevisitMenu";
import ChooseSpendModePrepaid from "../anonymousOnboarding/prepaidOrderingComps/ChooseSpendModePrepaid";
import BrandMenuPrepaid from "../anonymousOnboarding/prepaidOrderingComps/BrandMenuPrepaid";
import AcknowledgeRedemptionScreen from "../bussiness/AcknowledgeRedemptionScreen";
import ManageOrders from "../bussiness/ManageOrders";
import GuestConversionScreen from "../anonymousOnboarding/GuestConversionScreen";
import { isAwaitingAck, setAwaitingAck } from "../../utils/guestConversionAck";

// const AppNav = () => {
//   const { isLoading, userToken } = useContext(AppContext);
//   const Stack = createStackNavigator();

//   useEffect(() => {
//     console.log("BASE", BASE_URL);
//     console.log("FRONT", FRONTEND_URL);
//   }, []);

//   // const linking = {
//   //   prefixes: ["https://getmeeza.com", "meeza://"], // matches scheme + domain
//   //   config: {
//   //     screens: {
//   //       // Tab navigator level
//   //       home: {
//   //         screens: {
//   //           // Stack inside HomeNavigation
//   //           CelebrateMe: "u/:username",
//   //         },
//   //       },
//   //       does: "does",
//   //       table: "table",
//   //       pulls: "pulls",
//   //     },
//   //   },
//   // };

//   // const linking = {
//   //   prefixes: [FRONTEND_URL],
//   //   config: {
//   //     screens: {
//   //       // 1. This matches your Tab.Screen name="home"
//   //       home: {
//   //         path: "", // This means: "Start looking at the root URL"
//   //         screens: {
//   //           // 2. This matches your Stack.Screen name="anonymousOnboarding"
//   //           // inside HomeNavigation
//   //           anonymousOnboarding: "b/:brandID/:w0",
//   //         },
//   //       },
//   //     },
//   //   },
//   // };

//   const linking = {
//     prefixes: [FRONTEND_URL],
//     config: {
//       screens: {
//         // Move this to the top level of the config
//         anonymousOnboarding: "b/:brandID/:waiterID",

//         // // Keep your other routes for when users ARE logged in
//         // MainApp: {
//         //   screens: {
//         //     home: "home",
//         //   }
//         // }
//       },
//     },
//   };

//   if (isLoading) {
//     return (
//       <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
//         <ActivityIndicator size={"large"} color={Colours.PRIMARY} />
//       </View>
//     );
//   }

//   // return (
//   //     <GestureHandlerRootView style={{ flex: 1 }}>
//   //         <View style={styles.container}>
//   //             {/* <NavigationContainer linking={linking}> */}
//   //             <NavigationContainer linking={linking}>
//   //                 {userToken !== null ? (<TabNavigations />) : (<GetStartedNavigation />)}
//   //                 {/* <TabNavigations />
//   //                 <GetStartedNavigation /> */}
//   //             </NavigationContainer>
//   //         </View>
//   //     </GestureHandlerRootView>
//   // )

//   const content = (
//     <View style={styles.container}>
//       <NavigationContainer linking={linking}>
//         {userToken !== null ? <TabNavigations /> : <GetStartedNavigation />}
//       </NavigationContainer>
//     </View>
//   );

//   // GestureHandlerRootView crashes on web in some setups
//   if (Platform.OS === "web") {
//     return content;
//   }

//   return <GestureHandlerRootView style={{ flex: 1 }}>{content}</GestureHandlerRootView>;
// };

// const AppNav = () => {
//   const { isLoading, userToken } = useContext(AppContext);
//   const Stack = createStackNavigator();

//   const linking = {
//     prefixes: [FRONTEND_URL],
//     config: {
//       screens: {
//         // This must match the name in the Stack.Screen below
//         anonymousOnboarding: "b/:brandID/:waiterID",
//         anonymousOnboardingOTP: "otp",
//       },
//     },
//   };

//   if (isLoading) {
//     return (
//       <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
//         <ActivityIndicator size={"large"} color={Colours.PRIMARY} />
//       </View>
//     );
//   }

//   const content = (
//     <View style={styles.container}>
//       <NavigationContainer linking={linking}>
//         {/* We create a Root Stack that always contains the anonymous screens */}
//         <Stack.Navigator screenOptions={{ headerShown: false }}>
//           {/* PUBLIC SCREENS - These are ALWAYS available regardless of userToken */}
//           <Stack.Screen name="anonymousOnboarding" component={AnonymousOnboarding} />
//           <Stack.Screen name="anonymousOnboardingOTP" component={AnonymousOnboardingOTP} />

//           {/* AUTHENTICATION SWITCH */}
//           {userToken !== null ? (
//             <Stack.Screen name="MainTabs" component={TabNavigations} />
//           ) : (
//             <Stack.Screen name="GetStarted" component={GetStartedNavigation} />
//           )}
//         </Stack.Navigator>
//       </NavigationContainer>
//     </View>
//   );

//   if (Platform.OS === "web") return content;
//   return <GestureHandlerRootView style={{ flex: 1 }}>{content}</GestureHandlerRootView>;
// };

const Stack = createStackNavigator();

const AppNav = () => {
  const { isLoading, auth, setAuth, setGoogleOnboardData } = useContext(AppContext);
  const navigationRef = useNavigationContainerRef();

  const userToken = auth?.accessToken || null;
  // const isProfileComplete = auth?.isProfileComplete;
  const isProfileComplete = auth?.isProfileComplete === true || auth?.isProfileComplete === "true";
  console.log("hEHR", isProfileComplete);
  console.log("auth?.hasPendingPrepaidOrder", auth?.hasPendingPrepaidOrder);

  // ── GUEST CONVERSION CHECKS ──
  const email = auth?.email || "";
  const phoneNumber = auth?.phoneNumber || "";

  // 1. Check if email is missing OR is an auto-generated placeholder (@guest.local)
  const isAutoGeneratedEmail =
    email.toLowerCase().endsWith("@guest.local") || email.toLowerCase().includes("@guest.local");
  const hasInvalidEmail = !email || isAutoGeneratedEmail;

  // 2. Check if phone number is missing
  const hasInvalidPhone = !phoneNumber || phoneNumber.trim() === "";

  console.log(
    "hasInvalidEmail",
    hasInvalidEmail,
    "hasInvalidPhone",
    hasInvalidPhone,
    "auth?.isGuest",
    auth?.isGuest,
  );

  // 3. Trigger condition: User is a guest AND (missing/placeholder email OR missing phone)
  // const needsGuestConversion = auth?.isGuest === true && (hasInvalidEmail || hasInvalidPhone);
  const needsGuestConversion = auth?.isGuest === true && hasInvalidEmail && hasInvalidPhone;

  const hasPendingPrepaidOrder = auth?.hasPendingPrepaidOrder === true;

  const hasUnacknowledgedRedemption = auth?.hasUnacknowledgedRedemption === true;

  // if (hasPendingPrepaidOrder === false || hasPendingPrepaidOrder === "false") {
  //   localStorage.removeItem("monnify_redirected");
  // }

  // if (hasPendingPrepaidOrder === false || hasPendingPrepaidOrder === "false") {
  //   sessionStorage.removeItem("monnify_redirected");
  // }

  console.log("auth...", auth);

  console.log("hasPendingPrepaidOrder", hasPendingPrepaidOrder);
  console.log("hasUnacknowledgedRedemption", hasUnacknowledgedRedemption);

  // ── NEW: CAPTURE INCOMING URL REDIRECT PAYLOADS FROM APPLE AUTH ──
  useEffect(() => {
    if (Platform.OS !== "web") return; // Only execute on browser environments
    if (!window.location.search) return; // Exit if there are no query parameters

    console.log("Hersjd");

    try {
      const urlParams = new URLSearchParams(window.location.search);
      const action = urlParams.get("action");
      const accessToken = urlParams.get("accessToken");
      const profileCompleteParam = urlParams.get("isProfileComplete");

      if (accessToken) {
        console.log("[OAuth Redirect Intercept] Token extracted successfully:", action);

        // Convert query string value safely into a standard boolean structure
        // const completeStatus = profileCompleteParam === "true";

        // Commit parameters into your centralized context memory core immediately
        setAuth({
          accessToken: accessToken,
          isProfileComplete: profileCompleteParam,
        });

        // Apple-specific — restore onboarding form data same as Google flow
        // if (action === "NAVIGATE_TO_ONBOARDING" && !completeStatus) {
        if (action === "NAVIGATE_TO_ONBOARDING") {
          console.log("Incomplete Apple Profile found. Restoring input form maps...");
          setGoogleOnboardData({
            username: urlParams.get("username") || "guest_",
            firstname: urlParams.get("firstname") || "",
            lastname: urlParams.get("lastname") || "",
            email: urlParams.get("email") || "",
            profilePicture:
              urlParams.get("profilePicture") ||
              "https://api.dicebear.com/7.x/pixel-art/svg?seed=Meeza",
            isGoogleAuth: true, // reuse same flag so existing onboarding screen works
          });
        }

        // Clean up the address bar immediately so users don't see ugly tokens
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    } catch (err) {
      console.error("Failed to parse incoming authentication query strings:", err);
    }
  }, [setAuth, setGoogleOnboardData]);

  // useEffect(() => {
  //   if (!navigationRef.isReady()) return;
  //   if (!userToken || isProfileComplete !== true) return;

  //   const currentRoute = navigationRef.getCurrentRoute()?.name;

  //   // FIX: Add an array of deep-link paths that authenticated users should be allowed to view!
  //   const allowedDeepLinks = [
  //     "main",
  //     "anonymousOnboarding",
  //     "friendJoinTable",
  //     "brandMenu",
  //     "payForTable",
  //     "chooseFlex",
  //     "revisitChoose",
  //     "revisitMenu",
  //   ];

  //   // If the current route is already one of our deep links, let them pass through cleanly!
  //   // if (allowedDeepLinks.includes(currentRoute)) return;
  //   if (allowedDeepLinks.includes(currentRoute)) {
  //     if (hasPendingPrepaidOrder && currentRoute !== "payForTable") {
  //       navigationRef.reset({
  //         index: 0,
  //         routes: [{ name: "payForTable" }],
  //       });
  //     }
  //     return;
  //   }

  //   // navigationRef.reset({
  //   //   index: 0,
  //   //   routes: [{ name: "main" }],
  //   // });
  //   navigationRef.reset({
  //     index: 0,
  //     routes: [{ name: hasPendingPrepaidOrder ? "payForTable" : "main" }],
  //   });
  // }, [userToken, isProfileComplete, hasPendingPrepaidOrder, navigationRef.isReady()]);

  const prevHasPendingRef = useRef(hasPendingPrepaidOrder);

  useEffect(() => {
    if (!navigationRef.isReady()) return;
    if (!userToken || isProfileComplete !== true) return;

    const currentRoute = navigationRef.getCurrentRoute()?.name;

    const paymentJustCompleted =
      prevHasPendingRef.current === true && hasPendingPrepaidOrder === false;
    prevHasPendingRef.current = hasPendingPrepaidOrder;

    const allowedDeepLinks = [
      // "acknowledgeRedemption",
      "anonymousOnboarding",
      "anonymousOnboardingOTP",
      "friendJoinTable",
      "brandMenu",
      "chooseFlex",
      "revisitChoose",
      "revisitMenu",
      "chooseSpendModePrepaid",
      "brandMenuPrepaid",
      // "manageOrders",
    ];

    // if (hasUnacknowledgedRedemption) {
    //   if (currentRoute !== "acknowledgeRedemption") {
    //     navigationRef.reset({
    //       index: 0,
    //       routes: [{ name: "acknowledgeRedemption" }],
    //     });
    //   }
    //   return;
    // }

    // User still has an unpaid/pending order.
    // Keep them inside PayForTable.
    if (hasPendingPrepaidOrder) {
      if (currentRoute !== "payForTable") {
        navigationRef.reset({
          index: 0,
          routes: [{ name: "payForTable" }],
        });
      }

      return;
    }

    // Force it right after a payment completes, even over an allowed deep link.
    if (paymentJustCompleted && needsGuestConversion) {
      setAwaitingAck();
      if (currentRoute !== "guestConversionScreen") {
        navigationRef.reset({ index: 0, routes: [{ name: "guestConversionScreen" }] });
      }
      return;
    }
    // if (paymentJustCompleted && needsGuestConversion) {
    //   if (currentRoute !== "guestConversionScreen") {
    //     navigationRef.reset({ index: 0, routes: [{ name: "guestConversionScreen" }] });
    //   }
    //   return;
    // }

    // Don't interfere with valid deep-link screens.
    if (allowedDeepLinks.includes(currentRoute)) {
      return;
    }

    // Persistent Guest Conversion Screen — stays until explicit Done ack.
    if (needsGuestConversion || isAwaitingAck()) {
      setAwaitingAck();
      if (currentRoute !== "guestConversionScreen") {
        navigationRef.reset({ index: 0, routes: [{ name: "guestConversionScreen" }] });
      }
      return;
    }

    // Priority 2: Persistent Guest Conversion Screen
    // if (needsGuestConversion) {
    //   if (currentRoute !== "guestConversionScreen") {
    //     navigationRef.reset({ index: 0, routes: [{ name: "guestConversionScreen" }] });
    //   }
    //   return;
    // }

    // No pending order anymore.
    // If the user was previously on PayForTable,
    // send them to the main app.
    if (currentRoute === "payForTable" || currentRoute === "guestConversionScreen") {
      navigationRef.reset({
        index: 0,
        routes: [{ name: "main" }],
      });

      return;
    }
  }, [userToken, isProfileComplete, hasPendingPrepaidOrder, needsGuestConversion]);

  const linking = {
    prefixes: [FRONTEND_URL],
    config: {
      screens: {
        // Auth screens map to root
        main: {
          path: "",
          screens: {
            home: {
              initialRouteName: "Home",
              screens: {
                manageOrders: "orders",
                // business_page: "bussinessData",
              },
            },
          },
        },
        getStarted: {
          path: "app",
        },

        // acknowledgeRedemption: "p/redemptionCode",
        // manageOrders: "b/manage-orders",
        chooseSpendModePrepaid: "p/:showId",
        brandMenuPrepaid: "p/menu",
        // Deep link screens
        // anonymousOnboarding: "b/:brandID/:waiterID",
        anonymousOnboarding: "b/:qrToken",
        anonymousOnboardingOTP: "b/otp",
        chooseFlex: "b/flex",
        brandMenu: "b/menuScreen",
        revisitChoose: "b/chooseRevisit",
        revisitMenu: "b/menuRevisit",
        friendJoinTable: "join/:tableToken",
        // guestConversionScreen: "b/guestConvert",
        payForTable: "b/pay",
        signup: "b/sign-up",
        signups: "b/new-signup",
        personal_bio: "b/user-bio",
        // user_identity: "b/user-id",
        user_identity: "b/user-id/:userId",
      },
    },
  };

  // if (isLoading) {
  //   return (
  //     <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
  //       <ActivityIndicator size="large" color={Colours.PRIMARY} />
  //     </View>
  //   );
  // }

  const isAuthResolving =
    isLoading ||
    (userToken !== null &&
      (auth?.isProfileComplete === null || auth?.isProfileComplete === undefined));

  if (isAuthResolving) {
    return (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <ActivityIndicator size="large" color={Colours.PRIMARY} />
      </View>
    );
  }

  const content = (
    <View style={styles.container}>
      <NavigationContainer
        linking={linking}
        ref={navigationRef}
        // onStateChange={(state) => console.log("NAV STATE CHANGED:", JSON.stringify(state))}
      >
        <Stack.Navigator screenOptions={{ headerShown: false }}>
          {/* =========================================================
            AUTH / MAIN APP SCREENS
            ========================================================= */}

          {userToken !== null ? (
            // auth?.isProfileComplete === null || auth?.isProfileComplete === undefined ? (
            //   // Session validation still resolving
            //   <Stack.Screen name="loading_gate">
            //     {() => (
            //       <View
            //         style={{
            //           flex: 1,
            //           justifyContent: "center",
            //           alignItems: "center",
            //         }}
            //       >
            //         <ActivityIndicator size="large" color={Colours.PRIMARY} />
            //       </View>
            //     )}
            //   </Stack.Screen>
            // ) :
            isProfileComplete ? (
              <>
                {/* MAIN APP — ALWAYS REGISTERED */}
                <Stack.Screen name="main" component={TabNavigations} />

                {/* PAYMENT SCREEN — ALWAYS REGISTERED */}
                <Stack.Screen name="payForTable" component={PayForTable} />
                {/* PERSISTENT GUEST CONVERSION SCREEN */}
                <Stack.Screen name="guestConversionScreen" component={GuestConversionScreen} />
                {/* <Stack.Screen
                  name="acknowledgeRedemption"
                  component={AcknowledgeRedemptionScreen}
                /> */}
              </>
            ) : (
              // Profile incomplete
              <Stack.Screen name="user_identity" component={IdentityScreen} />
            )
          ) : (
            // No authentication
            <Stack.Screen name="getStarted" component={GetStartedNavigation} />
          )}
          {/* =========================================================
              GLOBALLY ACCESSIBLE ROUTES (AUTH & GUEST)
             ========================================================= */}
          {/* ── PREPAID PROMOTER FLOW ── */}
          <Stack.Screen name="chooseSpendModePrepaid" component={ChooseSpendModePrepaid} />
          <Stack.Screen name="brandMenuPrepaid" component={BrandMenuPrepaid} />

          {/* ── STANDARD FLOWS ── */}
          <Stack.Screen name="chooseFlex" component={ChooseYourFlexSpend} />

          <Stack.Screen name="brandMenu" component={BrandMenuScreen} />

          <Stack.Screen name="anonymousOnboarding" component={CreateYourVirtualTableScreen} />

          {/* <Stack.Screen name="acknowledgeRedemption" component={AcknowledgeRedemptionScreen} /> */}

          <Stack.Screen name="friendJoinTable" component={TableInvitationCheckout} />

          <Stack.Screen name="anonymousOnboardingOTP" component={AnonymousOnboardingOTP} />

          <Stack.Screen name="revisitChoose" component={RevisitChooseYourSpend} />

          <Stack.Screen name="revisitMenu" component={RevisitMenu} />

          <Stack.Screen name="signup" component={GoogleSign} />

          {/* <Stack.Screen name="manageOrders" component={ManageOrders} /> */}

          <Stack.Screen name="personal_bio" component={PersonalDetailsScreen} />
        </Stack.Navigator>
      </NavigationContainer>
    </View>
  );

  if (Platform.OS === "web") return content;

  return <GestureHandlerRootView style={{ flex: 1 }}>{content}</GestureHandlerRootView>;
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    // height: "100%",
    backgroundColor: "#fff",
  },

  // container: {
  //   flex: 1,
  //   backgroundColor: "#fff",

  //   // IMPORTANT for web PWAs
  //   height: "100vh",
  //   overflow: "hidden",
  // },
});

export default AppNav;
